module.exports = __webpack_public_path__ + "static/headerV2-aa2a976efc404726899621343ac2ef48.jpg";